import { setAllHtmlElements } from '../slices';

export const initializeHtmlElements = (payload) => (dispatch) => {
  dispatch(setAllHtmlElements(payload));
};
